export default __webpack_public_path__ + "static/media/mainFoto.f46545aa.png";